module.exports = __webpack_public_path__ + "img/e.b78b1871.jpg";